import { createFileRoute } from '@tanstack/react-router';
import CTA from '@/components/CTA';
import FAQ from '@/components/FAQ';
import Features from '@/components/Features';
import Footer from '@/components/Footer';
import Hero from '@/components/Hero';
import Navbar from '@/components/Navbar';
import Team from '@/components/Team';
import UseCases from '@/components/UseCases';

export function Index() {
  return (
    <div className="bg-black text-white min-h-screen">
      <Navbar />
      <Hero />
      <Features />
      <UseCases />
      <Team />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}

export const Route = createFileRoute('/')({
  component: Index,
});
